import { useSyncExternalStore } from 'react'

/** Phones: below Tailwind's `md`, where the tab capsule replaces the sidebar. */
export const PHONE_QUERY = '(max-width: 767.98px)'

/**
 * Whether a media query matches, live.
 *
 * For the screens that render a DIFFERENT TREE on a phone rather than the
 * same tree restyled. Hiding one layout with CSS would still mount it — every
 * card inside would run its effects twice (the settings cards read
 * credentials from the database on mount). When the two layouts share
 * components that fetch, render one of them, not both.
 *
 * Read synchronously on first render (this is a SPA — there is no server
 * pass to disagree with), so a phone never flashes the desktop layout.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mq = window.matchMedia(query)
      mq.addEventListener('change', onChange)
      return () => mq.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}
